import { render, staticRenderFns } from "./mineTestOrderNum.vue?vue&type=template&id=add56cf4&"
import script from "./mineTestOrderNum.vue?vue&type=script&lang=js&"
export * from "./mineTestOrderNum.vue?vue&type=script&lang=js&"
import style0 from "./mineTestOrderNum.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/show/mine/mineTestOrderNum.vue
// module id = null
// module chunks = 